import React from "react";

export default function Text(
  {
    noselect,
    singleLine,
    pointer,
    mt,
    mb,
    ml,
    mr,
    pt,
    pb,
    pl,
    pr,
    width,
    size,
    transform,
    underline,
    align,
    // styling
    bold,
    semibold,
    regular,
    light,
    weight,
    center,
    right,
    spacing, // letter-spacing
    height, // line-height
    // colors
    color,
    style,
    children,
    ...props
  }
) {

  const textStyles = [
    styles.text,
    noselect && { userSelect: "none" },
    singleLine && { whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", width: "100%" },
    pointer && { cursor: "pointer" },
    mt && { marginTop: mt },
    mb && { marginBottom: mb },
    ml && { marginLeft: ml },
    mr && { marginRight: mr },
    pt && { paddingTop: pt },
    pb && { paddingBottom: pb },
    pl && { paddingLeft: pl },
    pr && { paddingRight: pr },
    width && { width },
    size && { fontSize: size },
    transform && { textTransform: transform },
    underline && { textDecorationLine: 'underline' },
    align && { textAlign: align },
    height && { lineHeight: `${height}px` },
    spacing && { letterSpacing: spacing },
    weight && { fontWeight: weight },
    semibold && styles.semibold,
    bold && styles.bold,
    regular && styles.regular,
    light && styles.light,
    center && styles.center,
    right && styles.right,
    color && { color },
    style // rewrite predefined styles
  ];

  return (
    <span style={textStyles.reduce((prev = {}, curr) => {
      if (!curr) return prev;
      return { ...prev, ...curr };
    })} {...props}>
      {children}
    </span>
  );
}

const styles = {
  // default style
  text: {
    fontFamily: "Normal",
    fontSize: 14,
    lineHeight: 16
  },
  // variations
  bold: {
    fontFamily: "Bold",
  },
  // position
  center: { textAlign: "center" },
  right: { textAlign: "right" }
};